// French translations
const fr = {
  common: {
    appName: "Protego",
    subtitle: "Outil mondial de vérification de conformité",
    footer: "Tous droits réservés",
    search: "Rechercher",
    profile: "Profil",
    admin: "Admin",
    loading: "Chargement...",
    welcome: "Bonjour",
    error: "Erreur",
    success: "Succès",
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    submit: "Soumettre",
    download: "Télécharger",
    monitor: "Surveiller",
    confirm: "Confirmer",
    processing: "Traitement...",
    completed: "Terminé",
    generating: "Génération...",
    retry: "Réessayer",
    unknown: "Inconnu",
    copyLink: "Copier le lien",
    copied: "Copié !",
    backToSearch: "Retour à la recherche",
    backToCases: "Retour aux cas",
    backToReport: "Retour au rapport",
    backToHistory: "Retour à l'historique",
    backToMonitoring: "Retour au monitoring",
    yes: "Oui",
    no: "Non",
    organization: "Organisation",
    active: "Actif",
    saving: "Enregistrement..."
  },
  welcomeSection: {
    advancedSearch: {
      title: "Recherche Avancée",
      description: "Les algorithmes intelligents de rapprochement nominatif détectent les variations d'orthographe et de structure."
    },
    confidenceScoring: {
      title: "Indice de Fiabilité",
      description: "Les résultats sont classés avec des niveaux de confiance détaillés pour identifier les correspondances pertinentes."
    },
    complianceReady: {
      title: "Prêt pour la Conformité",
      description: "Générez des rapports de vérification avec des identifiants uniques pour la conformité réglementaire."
    }
  },
  search: {
    placeholder: "Entrez un nom à vérifier dans les listes de sanctions...",
    button: "Rechercher",
    advancedOptions: "Options Avancées",
    noResults: "Aucun résultat trouvé",
    resultsCount: "{{count}} résultats trouvés",
    entityType: "Type d'Entité",
    personType: "Personnes",
    enterpriseType: "Sociétés",
    confidence: {
      veryHigh: "Très Élevée",
      high: "Élevée",
      medium: "Moyenne",
      low: "Faible"
    },
    searching: "Recherche dans les listes de sanctions...",
    loading: "Chargement...",
    scanningRecords: "Analyse des enregistrements de la base de données",
    processed: "Traités",
    of: "sur",
    records: "enregistrements",
    searchResults: "Résultats de Recherche",
    foundMatches: "{{count}} correspondances trouvées pour \"{{term}}\"",
    showingTop: "Affichage des {{shown}} meilleures correspondances sur un total de {{total}} (triées par pertinence)",
    all: "Tous",
    riskMatch: "Correspondance à Risque",
    veryHighRiskMatch: "Correspondance à Risque Très Élevé",
    highRiskMatch: "Correspondance à Risque Élevé",
    mediumRiskMatch: "Correspondance à Risque Moyen",
    lowRiskMatch: "Correspondance à Risque Faible",
    filters: {
      all: "Tous",
      veryHigh: "Très Élevé",
      high: "Élevé",
      medium: "Moyen",
      low: "Faible"
    },
    includeDismissed: "Inclure les rejetés",
    searchId: "ID de recherche",
    caseStatus: "Statut du cas",
    caseStatusPending: "En attente d'examen",
    caseStatusPartial: "Partiellement examiné",
    caseStatusCompleted: "Examen terminé",
    name: "Nom",
    companyName: "Nom de l'entreprise"
  },
  results: {
    noSanctionsFound: "Aucune sanction trouvée",
    cleared: "n'apparaît sur aucune liste de sanctions. Cet individu a été vérifié par rapport à toutes les bases de données de sanctions surveillées.",
    clearedEntity: "n'apparaît sur aucune liste de sanctions. Cette entité a été vérifiée par rapport à toutes les bases de données de sanctions surveillées.",
    individualCleared: "Cet individu a été vérifié par rapport à toutes les bases de données de sanctions surveillées.",
    companyCleared: "Cette entreprise a été vérifiée par rapport à toutes les bases de données de sanctions surveillées.",
    verificationId: "ID de Vérification",
    recordsScanned: "Enregistrements Analysés",
    searchTimestamp: "Horodatage de Recherche",
    downloadPdfReport: "Télécharger le Rapport PDF",
    addToMonitoring: "Ajouter à la Surveillance",
    sourcesChecked: "Sources Vérifiées",
    financialSanctions: "Sanctions Financières",
    travelBans: "Interdictions de Voyage",
    unSanctions: "Sanctions ONU",
    databaseChecked: "Base de données vérifiée",
    disclaimer: "Ce résultat de contrôle est une vérification ponctuelle et ne garantit pas le statut de conformité futur.",
    legalNote: "À des fins de conformité légale, veuillez conserver une copie de ce rapport.",
    generatingPdf: "Génération du Rapport PDF...",
    generatingPdfReport: "Génération du Rapport PDF",
    scoreBreakdown: "Détail du Score",
    tokenMatch: "Correspondance de Jetons",
    positional: "Positionnel",
    transliteration: "Translittération",
    distributedMatchBoost: "Amplification de Correspondance Distribuée",
    culturalPattern: "Modèle Culturel",
    distributedNameMatch: "Rapprochement Nominatif Distribué",
    crossMatchExplanation: "Votre terme de recherche \"{{term}}\" correspond à cet enregistrement car différentes parties apparaissent dans plusieurs variantes de nom :",
    matchedVariants: "Variantes Correspondantes",
    sanctionsDetails: "Détails des Sanctions",
    category: "Catégorie",
    program: "Programme",
    listingDate: "Date d'Inscription",
    lastUpdated: "Dernière Mise à Jour",
    documents: "Documents",
    sanctionsReport: "Rapport de Sanctions",
    clearanceReport: "Rapport de Dédouanement",
    issuedBy: "Émis par",
    issuedByValue: "Protego",
    expiry: "Valable Jusqu'au",
    reportTimestamp: "Date de génération du rapport",
    searchDate: "Date de recherche",
    validUntil: "Valide jusqu'au",
    sanctionType: "Type de sanction",
    issueDate: "Date d'émission",
    country: "Pays",
    moreDetails: "Plus de détails",
    citizenship: "Nationalité",
    alternativeNames: "Noms Alternatifs",
    documentId: "ID du Document",
    viewOnEUSanctionsTracker: "Voir sur le Traceur de Sanctions UE",
    viewOnUNSecurityCouncilSanctionsList: "Voir sur la Liste des Sanctions du Conseil de Sécurité de l'ONU",
    function: "Fonction",
    fuzzy: "approximatif",
    dismiss: "Rejeter",
    confirmMatch: "Confirmer la correspondance",
    confirmed: "Confirmé",
    dismissed: "Rejeté",
    confirmDismiss: "Rejeter comme faux positif ?",
    dismissExplanation: "Cela marquera le résultat comme rejeté et l'enregistrera comme un faux positif dans votre système de gestion de cas.",
    undoReview: "Annuler la décision",
    removeFromMonitoring: "Supprimer de la surveillance"
  },
  report: {
    title: "Rapport de vérification",
    subjectInformation: "Informations sur le sujet",
    name: "Nom",
    generated: "Rapport généré",
    screeningDetails: "Détails de la vérification",
    authoritiesChecked: "Autorités vérifiées",
    verification: "Vérification",
    issuedBy: "Émis par",
    issuedByValue: "Protego",
    verifyAt: "Vérifier à",
    verificationDisclaimer: "Ce rapport est une vérification ponctuelle et ne garantit pas le statut de conformité futur.",
    generatedOn: "Généré le",
    verificationId: "ID de Vérification",
    runBy: "Exécuté par"
  },
  authorities: {
    euCommission: "European Commission",
    euCommissionDescription: "Sanctions financières, Interdictions de voyage",
    unitedNations: "United Nations",
    unitedNationsDescription: "Sanctions du Conseil de sécurité"
  },
  auth: {
    login: "Connexion",
    signup: "Inscription",
    logout: "Déconnexion",
    welcomeBack: "Bienvenue",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Récupérer votre mot de passe",
    resetPasswordPrompt: "Entrez votre email pour recevoir un lien de réinitialisation du mot de passe",
    sendResetLink: "Envoyer le lien de réinitialisation",
    backToLogin: "Retour à la connexion",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    dontHaveAccount: "Vous n'avez pas de compte ?",
    noAccount: "Vous n'avez pas de compte ?",
    createAccount: "Créer un compte",
    loginNow: "Connectez-vous pour continuer vers le Contrôleur de Sanctions",
    enterEmail: "Entrez votre email",
    enterPassword: "Entrez votre mot de passe",
    enterName: "Entrez votre nom",
    confirmYourPassword: "Confirmez votre mot de passe",
    passwordsDontMatch: "Les mots de passe ne correspondent pas",
    accountCreated: "Compte créé avec succès !",
    accountCreatedSuccessfully: "Compte créé avec succès ! Vous êtes maintenant connecté.",
    passwordResetEmailSent: "Email de réinitialisation du mot de passe envoyé ! Vérifiez votre boîte de réception.",
    resetLinkSent: "Lien de réinitialisation envoyé à votre email.",
    checkEmail: "Veuillez vérifier votre email.",
    loginError: "La connexion a échoué. Veuillez vérifier vos identifiants.",
    signupError: "Échec de création du compte. L'email est peut-être déjà utilisé.",
    resetError: "Échec d'envoi de l'email de réinitialisation. Veuillez vérifier l'adresse email.",
    switchToLightMode: "Mode Clair",
    switchToDarkMode: "Mode Sombre",
    name: "Nom",
    resetPasswordInstructions: "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
    or: "ou",
    continueWithGoogle: "Continuer avec Google",
    continueWithMicrosoft: "Se connecter avec Microsoft",
    emailVerificationRequired: "Veuillez vérifier votre email avant de continuer. Consultez votre boîte de réception pour un lien de vérification.",
    verificationEmailSent: "Un email de vérification a été envoyé à votre adresse email. Veuillez vérifier votre boîte de réception et valider votre email avant de continuer.",
    verificationEmailResent: "L'email de vérification a été renvoyé. Veuillez vérifier votre boîte de réception.",
    verificationRequired: "Veuillez vérifier votre adresse email pour continuer.",
    resendVerification: "Renvoyer l'email de vérification",
    emailVerified: "Email vérifié avec succès !",
    verifyYourEmail: "Confirmez Votre Adresse Email",
    verificationInstructions: "Nous avons envoyé un email de vérification à votre adresse email. Veuillez vérifier votre boîte de réception et cliquer sur le lien de vérification pour activer votre compte.",
    iAlreadyVerified: "J'ai déjà vérifié mon email",
    emailNotVerified: "Votre email n'est pas encore vérifié. Veuillez vérifier votre boîte de réception.",
    resendVerificationError: "Échec du renvoi de l'email de vérification. Veuillez réessayer plus tard.",
    resendIn: "Renvoyer dans",
    resendCooldown: "Veuillez patienter avant de demander un autre email.",
    loginRequired: "Veuillez vous connecter pour accéder à cette page.",
    verificationPageTitle: "Vérification d'Email Requise"
  },
  orgAdmin: {
    title: "Administration de l'Organisation",
    subtitle: "Gérer votre organisation : {{orgName}}",
    accessDenied: "Accès Refusé",
    accessDeniedMessage: "Vous n'avez pas la permission d'accéder à la page d'administration de l'organisation. Seuls les administrateurs de l'organisation peuvent voir ce contenu.",
    tabs: {
      userManagement: "Gestion des Utilisateurs",
      organizationSettings: "Paramètres de l'Organisation",
      billingSubscription: "Facturation & Abonnement"
    },
    userManagement: {
      title: "Membres de l'Organisation",
      subtitle: "Gérer les utilisateurs de votre organisation",
      inviteUser: "Inviter un Utilisateur",
      inviteNewUser: "Inviter un Nouvel Utilisateur",
      emailAddress: "Adresse Email",
      emailPlaceholder: "utilisateur@exemple.com",
      role: "Rôle",
      roles: {
        member: "Membre",
        admin: "Administrateur"
      },
      sendInvitation: "Envoyer l'Invitation",
      pendingInvitations: "Invitations en Attente",
      inviteCode: "Code d'Invitation",
      cancelInvitation: "Annuler l'invitation",
      activeMembers: "Membres Actifs",
      user: "Utilisateur",
      joined: "Rejoint",
      actions: "Actions",
      unknown: "Inconnu",
      confirmRemoveUser: "Êtes-vous sûr de vouloir retirer cet utilisateur de l'organisation ?",
      userAlreadyExists: "L'utilisateur fait déjà partie de cette organisation",
      emailRequired: "L'email est requis",
      inviteUserFailed: "Échec de l'invitation de l'utilisateur. Veuillez réessayer.",
      updateRoleFailed: "Échec de la mise à jour du rôle de l'utilisateur",
      cancelInviteFailed: "Échec de l'annulation de l'invitation",
      removeUserFailed: "Échec de la suppression de l'utilisateur",
      loadUsersFailed: "Échec du chargement des utilisateurs",
      teamMemberLimit: {
        exceeded: "Limite de membres d'équipe dépassée",
        warning: "Vous avez {{current}}/{{limit}} membres d'équipe",
        cannotJoin: "Cette organisation a atteint sa limite maximale de membres d'équipe",
        cannotInvite: "Impossible d'inviter plus de membres d'équipe. Mettez à niveau votre plan pour en ajouter plus.",
        currentCount: "{{current}}/{{limit}} Membres d'équipe",
        upgradeRequired: "Mettez à niveau votre plan pour ajouter plus de membres d'équipe",
        atLimit: "Vous avez atteint votre limite de membres d'équipe",
        nearLimit: "Vous approchez de votre limite de membres d'équipe"
      }
    },
    organizationSettings: {
      title: "Paramètres de l'Organisation",
      subtitle: "Configurer les paramètres globaux de votre organisation",
      organizationDetails: "Détails de l'Organisation",
      organizationName: "Nom de l'Organisation",
      domain: "Domaine",
      domainCannotChange: "Le domaine ne peut pas être modifié après la création de l'organisation",
      defaultSearchSettings: "Paramètres de Recherche par Défaut",
      defaultSearchCadence: "Cadence de Recherche par Défaut",
      defaultCadenceHelp: "Cadence par défaut pour les nouveaux utilisateurs",
      timezone: "Fuseau Horaire",
      cadenceOptions: {
        "1year": "1 An",
        "6months": "6 Mois",
        "3months": "3 Mois",
        "1month": "1 Mois"
      },
      timezoneOptions: {
        "UTC": "UTC",
        "America/New_York": "Heure de l'Est",
        "America/Chicago": "Heure Centrale",
        "America/Denver": "Heure des Montagnes",
        "America/Los_Angeles": "Heure du Pacifique",
        "Europe/London": "Londres",
        "Europe/Paris": "Paris",
        "Europe/Berlin": "Berlin",
        "Asia/Tokyo": "Tokyo",
        "Asia/Shanghai": "Shanghai"
      },
      saveChanges: "Enregistrer les Modifications",
      settingsUpdated: "Paramètres mis à jour avec succès",
      settingsUpdateFailed: "Échec de la mise à jour des paramètres. Veuillez réessayer."
    },
    billing: {
      title: "Facturation & Abonnement",
      subtitle: "Gérer l'abonnement et les informations de facturation de votre organisation",
      trialActive: "Période d'Essai Active",
      trialDaysRemaining: "{{days}} jours restants dans votre essai",
      trialExpired: "Votre essai a expiré",
      upgradeNow: "Mettre à Niveau Maintenant",
      currentSubscription: "Abonnement Actuel",
      plan: "Plan",
      status: "Statut",
      nextBillingDate: "Prochaine Date de Facturation",
      unknownPlan: "Plan Inconnu",
      paymentRequired: "Paiement Requis",
      paymentOverdue: "Le paiement de votre abonnement est en retard. Veuillez mettre à jour votre méthode de paiement.",
      noActiveSubscription: "Aucun Abonnement Actif",
      noSubscriptionMessage: "Votre organisation n'a pas encore d'abonnement actif.",
      organizationUsage: "Utilisation de l'Organisation",
      activeMembers: "Membres Actifs",
      searchesThisMonth: "Recherches ce Mois",
      activeCases: "Cas Actifs",
      apiCallsThisMonth: "Appels API ce Mois",
      billingActions: "Actions de Facturation",
      manageSubscription: "Gérer l'Abonnement",
      manageSubscriptionDesc: "Mettre à jour la méthode de paiement, voir les factures, changer de plan",
      notAvailableDuringTrial: "Non disponible pendant la période d'essai",
      opening: "Ouverture...",
      usageAnalytics: "Analytiques d'Utilisation",
      usageAnalyticsDesc: "Rapports d'utilisation détaillés et analytiques (Bientôt Disponible)",
      needHelp: "Besoin d'Aide ?",
      needHelpMessage: "Si vous avez des questions sur la facturation ou devez apporter des modifications à votre abonnement, notre équipe de support est là pour vous aider.",
      contactSupport: "Contacter le Support →"
    }
  },
  profile: {
    title: "Paramètres du compte",
    personalInfo: "Informations Personnelles",
    accountSettings: "Paramètres du Compte",
    usageHistory: "Historique d'Utilisation",
    savedSearches: "Recherches Enregistrées",
    monitoredEntities: "Entités Surveillées",
    apiKeys: "Clés API",
    updateProfile: "Mettre à jour le Profil",
    changePassword: "Changer le Mot de Passe",
    deleteAccount: "Supprimer le Compte",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée.",
    currentPassword: "Mot de Passe Actuel",
    newPassword: "Nouveau Mot de Passe",
    confirmNewPassword: "Confirmer le Nouveau Mot de Passe",
    passwordUpdated: "Mot de passe mis à jour avec succès",
    profileUpdated: "Profil mis à jour avec succès",
    searchHistory: "Historique des Recherches",
    recentSearches: "Recherches Récentes",
    noSearchesYet: "Pas encore de recherches",
    searchCount: "Nombre de Recherches",
    lastSearch: "Dernière Recherche",
    monitoredSince: "Surveillé Depuis",
    monitoringStatus: "Statut de Surveillance",
    active: "Actif",
    inactive: "Inactif",
    apiKeyInfo: "Les clés API vous permettent d'intégrer l'API du Contrôleur de Sanctions",
    createNewKey: "Créer une Nouvelle Clé API",
    keyCreated: "Nouvelle clé API créée",
    copyKey: "Copier la Clé",
    revokeKey: "Révoquer la Clé",
    lastUsed: "Dernière Utilisation",
    neverUsed: "Jamais Utilisée",
    emailNotifications: "Notifications par Email",
    enableNotifications: "Activer les notifications par email pour les entités surveillées",
    notificationFrequency: "Fréquence des Notifications",
    daily: "Quotidienne",
    weekly: "Hebdomadaire",
    monthly: "Mensuelle",
    savedReports: "Rapports Enregistrés",
    downloadReport: "Télécharger le Rapport",
    accountCreated: "Compte créé",
    lastSignIn: "Dernière connexion",
    subscription: "Abonnement",
    organizationSubscription: "Abonnement de l'Organisation",
    organization: "Organisation",
    role: "Rôle",
    admin: "Administrateur de l'Organisation",
    member: "Membre",
    manageSubscription: "Gérer l'abonnement",
    subscribeNow: "S'abonner maintenant",
    noSubscription: "Vous n'avez pas d'abonnement actif.",
    noOrganizationSubscription: "Votre organisation n'a pas d'abonnement actif.",
    contactAdmin: "Contactez votre administrateur d'organisation pour gérer la facturation et les abonnements.",
    status: "Statut",
    tier: "Niveau",
    professional: "Professionnel",
    starter: "Débutant",
    paymentOverdue: "Paiement en retard",
    nextBilling: "Prochaine facturation",
    marketingPreferences: "Préférences Marketing",
    sanctionsUpdates: "Mises à jour Sanctions et Conformité",
    marketingDescription: "Recevez des alertes prioritaires sur les mises à jour critiques des sanctions, les changements réglementaires et les nouvelles fonctionnalités de conformité qui pourraient affecter votre entreprise.",
    marketingOn: "Vous recevrez des communications marketing",
    marketingOff: "Vous ne recevrez pas de communications marketing",
    marketingEnabled: "Notifications marketing activées",
    marketingDisabled: "Notifications marketing désactivées"
  },
  billing: {
    adminRequired: "Accès administrateur d'organisation requis"
  },
  payment: {
    success: {
      title: "Merci pour votre abonnement !",
      subtitle: "Bienvenue dans le contrôle des sanctions amélioré",
      planActive: "Votre abonnement est maintenant actif",
      features: "Votre forfait comprend :",
      nextRenewal: "Prochain renouvellement",
      stayUpdated: "Restez à jour des changements de sanctions",
      marketingText: "Recevez des alertes prioritaires sur les mises à jour critiques des sanctions, les changements réglementaires et les nouvelles fonctionnalités de conformité qui pourraient affecter votre entreprise.",
      marketingOptIn: "Oui, tenez-moi informé des mises à jour importantes sur les sanctions et la conformité",
      continue: "Continuer vers le tableau de bord",
      footerNote: "Vous pouvez gérer votre abonnement et vos préférences à tout moment dans les paramètres de votre compte."
    }
  },
  themes: {
    light: "Mode Clair",
    dark: "Mode Sombre"
  },
  language: {
    en: "Anglais",
    hr: "Croate",
    de: "Allemand",
    fr: "Français",
    switchTo: "Changer de langue",
    comingSoon: "Bientôt Disponible"
  },
  cookies: {
    consent: "Ce site utilise des cookies pour améliorer l'expérience utilisateur.",
    accept: "Accepter",
    deny: "Refuser",
    privacyPolicy: "Politique de Confidentialité"
  },
  errors: {
    general: "Une erreur s'est produite. Veuillez réessayer.",
    login: "Email ou mot de passe invalide.",
    required: "Ce champ est obligatoire.",
    invalidEmail: "Veuillez entrer une adresse email valide.",
    passwordMatch: "Les mots de passe ne correspondent pas.",
    passwordLength: "Le mot de passe doit comporter au moins 8 caractères.",
    passwordRequirements: "Exigences de mot de passe :",
    passwordMinLength: "10+ caractères",
    passwordUppercase: "1+ lettre majuscule",
    passwordLowercase: "1+ lettre minuscule",
    passwordNumber: "1+ chiffre",
    passwordSpecial: "1+ caractère spécial",
    serverError: "Erreur serveur. Veuillez réessayer plus tard.",
    notFound: "Page non trouvée",
    unauthorized: "Vous n'êtes pas autorisé à effectuer cette action.",
    forbidden: "Accès interdit.",
    offline: "Vous semblez être hors ligne. Veuillez vérifier votre connexion.",
    timeout: "La requête a expiré. Veuillez réessayer.",
    conflict: "Cette opération a causé un conflit. Veuillez réessayer.",
    emptyResult: "Aucun résultat trouvé. Veuillez essayer un terme de recherche différent.",
    validation: "Veuillez corriger les erreurs dans le formulaire.",
    jobNotFound: "Le job demandé n'a pas été trouvé.",
    jobAccessDenied: "Vous n'avez pas la permission d'accéder à ce job.",
    noVerificationId: "Aucun ID de vérification disponible pour cette correspondance.",
    pdfGenerationFailed: "Une erreur s'est produite lors de la génération du rapport PDF.",
    downloadFailed: "Échec du téléchargement des résultats. Veuillez réessayer.",
    googleAuthFailed: "L'authentification Google a échoué. Veuillez réessayer.",
    popupClosed: "La fenêtre d'authentification a été fermée. Veuillez réessayer.",
    accountExists: "Un compte existe déjà avec la même adresse email."
  },
  pdf: {
    pageOf: "Page {{current}} sur {{total}}",
    sanctionsCheckHeader: "Résultats de Vérification des Sanctions",
    verified: "VÉRIFIÉ",
    flagged: "SIGNALÉ",
    disclaimer: "AVERTISSEMENT : Ce rapport est fourni à titre informatif uniquement et ne constitue pas un avis juridique. Les informations contenues dans ce rapport sont exactes à la date de génération.",
    confidential: "CONFIDENTIEL - POUR USAGE AUTORISÉ UNIQUEMENT"
  },
  history: {
    history: "Historique",
    viewHistory: "Voir l'Historique de Recherche",
    searchHistory: "Historique de Recherche",
    yourRecentSearches: "Vos recherches récentes dans toutes les listes de sanctions",
    loading: "Chargement de votre historique de recherche...",
    loadMore: "Charger Plus",
    noSearchesYet: "Pas encore de recherches",
    searchesToAppearHere: "Vos recherches apparaîtront ici après avoir recherché un nom",
    recordsScanned: "Enregistrements Analysés",
    matchesFound: "Correspondances Trouvées",
    verificationId: "ID de Vérification",
    sourcesChecked: "Sources Vérifiées",
    backToHistory: "Retour à l'historique",
    searchDetails: "Détails de la Recherche",
    matchedEntities: "Entités Correspondantes",
    rerunSearch: "Lancer une Nouvelle Recherche",
    runningSearch: "Recherche en cours...",
    rerunResults: "Résultats de la Nouvelle Recherche",
    matches: "Correspondances",
    moreMatches: "autres correspondances",
    noMatches: "Aucune correspondance trouvée",
    rerunError: "Erreur lors de l'exécution de la recherche",
    filterSearches: "Filtrer votre historique de recherche...",
    searching: "Recherche en cours...",
    noMatchingSearches: "Aucune recherche correspondant à votre filtre"
  },
  monitoring: {
    addedSuccess: "Ajouté à la surveillance avec succès",
    addError: "Échec de l'ajout à la surveillance",
    removedSuccess: "Retiré de la surveillance avec succès",
    removeError: "Échec du retrait de la surveillance",
    missingVerificationId: "ID de vérification manquant pour la surveillance",
    alreadyMonitored: "Cette entité est déjà surveillée",
    notMonitored: "Cette entité n'est pas surveillée",
    title: "Surveillance",
    description: "Suivez les entités et revérifiez-les automatiquement sur une base régulière",
    emptyMessage: "Ajoutez des noms à surveiller depuis la page de résultats de recherche",
    noMonitoredSearches: "Aucune entité surveillée",
    totalMonitored: "Total Surveillé",
    verificationId: "ID de Vérification",
    addedOn: "Ajouté le",
    lastChecked: "Dernière Vérification",
    runSearch: "Lancer la Recherche",
    removeFromMonitoring: "Retirer",
    fetchError: "Échec du chargement des entités surveillées",
    searchError: "Une erreur s'est produite lors de la recherche",
    errorTitle: "Erreur de Chargement de la Surveillance",
    indexBuildingError: "L'index de recherche est en cours de construction. Veuillez réessayer dans une minute.",
    searchCadenceLabel: "Fréquence de Revérification Automatique",
    cadenceDescription: "Choisissez la fréquence à laquelle nous devrions automatiquement revérifier ces noms par rapport aux dernières données de sanctions",
    cadence3Months: "Tous les 3 mois",
    cadence6Months: "Tous les 6 mois",
    cadence9Months: "Tous les 9 mois",
    cadence1Year: "Une fois par an",
    cadence2Years: "Tous les 2 ans",
    cadenceSaved: "Fréquence de revérification enregistrée",
    saveCadenceError: "Échec de l'enregistrement de la fréquence de revérification",
    filterMonitored: "Filtrer les entités surveillées...",
    searching: "Recherche en cours...",
    noMatchingSearches: "Aucune entité surveillée correspondant à votre filtre"
  },
  user: {
    profile: "Profil",
    settings: "Paramètres",
    account: "Compte",
    history: "Historique",
    language: "Langue",
    theme: "Thème",
    notifications: "Notifications",
    security: "Sécurité",
    personalInfo: "Informations personnelles",
    changePassword: "Changer le mot de passe",
    twoFactor: "Authentification à deux facteurs",
    firstName: "Prénom",
    lastName: "Nom",
    company: "Entreprise",
    position: "Poste",
    phoneNumber: "Numéro de téléphone",
    address: "Adresse",
    update: "Mettre à jour le profil",
    profileUpdated: "Profil mis à jour avec succès",
    oldPassword: "Ancien mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordChanged: "Mot de passe changé avec succès"
  },
  admin: {
    dashboard: "Tableau de bord",
    users: "Utilisateurs",
    searchHistory: "Historique de recherche",
    monitoring: "Surveillance",
    settings: "Paramètres",
    systemStatus: "État du système",
    viewLogs: "Voir les journaux",
    updateDatabase: "Mettre à jour la base de données",
    addUser: "Ajouter un utilisateur",
    editUser: "Modifier l'utilisateur",
    deleteUser: "Supprimer l'utilisateur",
    statistics: "Statistiques",
    apiKeys: "Clés API",
    integrations: "Intégrations",
    createApiKey: "Créer une clé API",
    revokeApiKey: "Révoquer la clé API",
    databaseStats: "Statistiques de la base de données",
    lastUpdate: "Dernière mise à jour",
    totalRecords: "Total des enregistrements",
    searchesPerDay: "Recherches par jour",
    activeUsers: "Utilisateurs actifs",
    monitoring: "Surveillance",
    totalMonitored: "Total des entités surveillées",
    alerts: "Alertes",
    addToMonitoring: "Ajouter à la surveillance",
    removeFromMonitoring: "Supprimer de la surveillance",
    monitoringFrequency: "Fréquence de surveillance",
    daily: "Quotidienne",
    weekly: "Hebdomadaire",
    monthly: "Mensuelle"
  },
  sidebar: {
    navigation: "Navigation",
    home: "Accueil",
    searchHistory: "Historique de Recherche",
    admin: "Admin",
    adminRole: "Administrateur",
    userRole: "Utilisateur",
    massUpload: "Importation Massive",
    monitoring: "Surveillance",
    cases: "Cas"
  },
  massUpload: {
    title: "Vérification en Masse",
    description: "Téléchargez et vérifiez plusieurs noms à la fois par rapport aux listes de sanctions",
    selectFile: "Sélectionnez un fichier CSV ou glissez-déposez",
    loadingJobs: "Chargement des tâches...",
    loadingResults: "Chargement des résultats consolidés...",
    loadingJobDetails: "Chargement des détails de la tâche...",
    loadMore: "Charger Plus de Jobs",
    loadingMore: "Chargement de Plus de Jobs...",
    noJobs: "Aucun job de vérification trouvé",
    startFirstJob: "Démarrez votre premier job de vérification",
    jobId: "ID du Job",
    startScreening: "Démarrer la Vérification",
    resume: "Reprendre la Vérification",
    processing: "Traitement...",
    pending: "En attente",
    completed: "Terminé",
    foundMatches: "Correspondances Trouvées",
    error: "Erreur",
    progress: "Progression",
    summaryTitle: "Résumé des Résultats de Vérification",
    totalProcessed: "Total Traité",
    namesWithMatches: "Noms avec Correspondances",
    namesWithoutMatches: "Noms sans Correspondances",
    totalMatchesFound: "Total des Correspondances Trouvées",
    clearAndNew: "Effacer & Nouveau",
    emptyStateMessage: "Téléchargez un fichier avec des noms pour commencer la vérification par lot",
    uploading: "Téléchargement du fichier...",
    namesLoaded: "{{count}} noms chargés",
    name: "Nom",
    status: "Statut",
    matches: "Correspondances",
    verificationId: "ID de Vérification",
    actions: "Actions",
    viewMatches: "Voir les Correspondances",
    hideMatches: "Masquer les Correspondances",
    matchDetails: "Détails de Correspondance",
    sanctionName: "Nom de Sanction",
    matchPercentage: "% de Correspondance",
    confidenceLevel: "Niveau de Confiance",
    sources: "Sources",
    noDetailedMatches: "Aucune information détaillée sur les correspondances disponible",
    noSourceInfo: "Aucune information sur la source",
    downloadPdf: "Télécharger PDF",
    viewFullReport: "Voir le Rapport Complet",
    jobsTitle: "Jobs de Vérification",
    newJob: "Nouveau Job",
    startTime: "Heure de Début",
    namesCount: "Noms",
    matchesFound: "Correspondances Trouvées",
    view: "Voir",
    viewJob: "Voir les Détails du Job",
    backToJobs: "Retour aux Jobs",
    currentJob: "Job Actuel",
    downloadResults: "Télécharger les Résultats en CSV",
    downloadSuccess: "Résultats téléchargés avec succès",
    continued: "Continué",
    completedWithErrors: "Terminé avec des erreurs",
    parentJobTitle: "Informations sur le Job Parent",
    showChildJobs: "Afficher les Lots",
    hideChildJobs: "Masquer les Lots",
    totalBatches: "Total des Lots",
    totalNames: "Total des Noms",
    highConfidenceMatches: "Correspondances à Haute Confiance",
    continuationChain: "Séquence de traitements liés",
    continuationExplanation: "Ce job fait partie d'une série de lots de vérification liés. Tous les jobs de la chaîne sont affichés ci-dessous avec leur statut actuel.",
    jobsInChain: "jobs dans cette chaîne",
    continuationInfo: "Info de Continuation",
    chainedJobs: "{{count}} jobs dans la chaîne",
    parentJob: "Job Parent",
    jobType: "Type de job",
    standardJob: "Job standard",
    jobPart: "Partie du job",
    cancelJob: "Annuler le Job",
    cancelling: "Annulation en cours...",
    stopping: "En cours d'arrêt",
    stopped: "Arrêté",
    jobCancellationRequested: "Annulation du job demandée. Le job s'arrêtera après avoir terminé le lot actuel.",
    couldNotCancelJob: "Impossible d'annuler le job",
    failedToCancelJob: "Échec de l'annulation du job",
    fileInfo: "Télécharger un fichier CSV ou TXT avec un nom par ligne",
    batchSizeLimit: "Maximum 250 noms par lot",
    oneJobLimit: "Un seul traitement par lot actif à la fois",
    limitReached: "Limite de recherche mensuelle atteinte",
    batchSizeLimitError: "Limite de taille de lot dépassée: Votre fichier contient {{count}} noms, mais le maximum autorisé est de 250. Veuillez diviser vos données en lots plus petits ou réduire le nombre de noms dans votre fichier.",
    activeJobError: "Vous avez déjà un traitement par lot actif. Veuillez attendre qu'il soit terminé avant d'en lancer un nouveau.",
    errorProcessingFile: "Erreur lors du traitement du fichier",
    downloadSample: "Télécharger un CSV exemple"
  },
  sources: {
    ofac: "OFAC",
    un: "Nations Unies",
    eu: "Union Européenne",
    uk: "Royaume-Uni",
    interpol: "Interpol",
    fbi: "FBI",
    pep: "PEP",
    global: "Sanctions Globales",
    treasury: "Trésor Américain",
    unsc: "Conseil de Sécurité de l'ONU",
    ustreas: "Trésor Américain",
    ustreasury: "Trésor Américain",
    unscr: "Résolution du Conseil de Sécurité de l'ONU",
    worldbank: "Banque Mondiale",
    ecb: "Banque Centrale Européenne",
    imf: "FMI",
    fsf: "Forum de Stabilité Financière",
    sanctionslist: "Liste de Sanctions",
    usstate: "Département d'État Américain",
    usdept: "Département Américain",
    canada: "Canada",
    australia: "Australie",
    japan: "Japon",
    osfi: "OSFI Canada",
    bis: "Bureau de l'Industrie et de la Sécurité",
    sdnlist: "Liste SDN",
    uktreasury: "Trésor Britannique",
    eucommission: "Commission Européenne",
    nsa: "Agence Nationale de Sécurité",
    nationalsecurity: "Sécurité Nationale",
    globalsanctions: "Sanctions Globales",
    sanctionsprogram: "Programme de Sanctions",
    debarredparties: "Parties Exclues",
    deniedpersons: "Personnes Refusées",
    entitylist: "Liste d'Entités"
  },
  cases: {
    title: "Gestion des Cas",
    loading: "Chargement des cas...",
    errorFetching: "Erreur lors du chargement des cas",
    noCases: "Aucun cas trouvé",
    totalCases: "Total des Cas",
    openCases: "Cas Ouverts",
    allOpenCases: "Tous Ouverts",
    inProgressCases: "En Cours",
    completedCases: "Terminés",
    matches: "Correspondances",
    reviewed: "Examinés",
    minute: "minute",
    minutes: "minutes",
    hour: "heure",
    hours: "heures",
    day: "jour",
    days: "jours",
    ago: "il y a",
    statusPending: "En Attente",
    statusInProgress: "En Cours",
    statusCompleted: "Terminé",
    refresh: "Actualiser",
    filters: {
      all: "Tous",
      allOpen: "Tous Ouverts",
      pending: "En Attente",
      inProgress: "En Cours",
      completed: "Terminés"
    },
    report: {
      downloadButton: "Télécharger le Rapport",
      tooltip: "Le rapport de cas ne peut être téléchargé qu'une fois toutes les correspondances potentielles examinées.",
      loading: "Génération du rapport...",
      error: "Erreur lors de la génération du rapport",
      caseCompleted: "Cas Terminé",
      casePending: "Le cas doit être entièrement examiné pour télécharger le rapport",
      matchesConfirmed: "Correspondances de Sanctions Confirmées",
      noMatchesConfirmed: "Aucune Correspondance de Sanctions",
      reviewedBy: "Examiné par",
      caseSummary: "Résumé du Cas",
      confirmedMatches: "correspondances confirmées",
      allMatchesCleared: "Toutes les correspondances effacées",
      statusUnknown: "Statut inconnu"
    }
  },
  cookies: {
    consent: "Ce site utilise des cookies pour améliorer l'expérience utilisateur.",
    accept: "Accepter",
    deny: "Refuser",
    privacyPolicy: "Politique de Confidentialité"
  },
  pastdue: {
    banner: "Votre paiement est en retard de {{days}} jours. Veuillez mettre à jour vos informations de paiement.",
    resolve: "Mettre à Jour le Mode de Paiement",
    modal: {
      title: "Paiement en Retard",
      message: "Le paiement de votre abonnement est en retard. Vous ne pouvez pas utiliser l'application tant que votre paiement n'est pas résolu.",
      button: "Mettre à Jour le Mode de Paiement"
    }
  },
  trial: {
    banner: "Votre version d'évaluation expire dans {{days}} jours. Passez à la version complète pour continuer à utiliser toutes les fonctionnalités.",
    daysRemaining: "{{days}} jours restants",
    status: "ÉVALUATION",
    upgrade: "Passer à la version complète",
    activeTitle: "Version d'Évaluation Active",
    description: "Vous profitez actuellement d'un accès complet à toutes les fonctionnalités Professionnelles pendant votre période d'évaluation gratuite.",
    upgradePrompt: "Passez à un plan payant avant la fin de votre version d'évaluation pour continuer à utiliser toutes les fonctionnalités."
  },
  pricing: {
    choose_plan: "Choisissez Votre Plan",
    upgrade_plan: "Améliorez Votre Plan",
    restart_subscription: "Redémarrez Votre Abonnement",
    subtitle: "Libérez toute la puissance du contrôle des sanctions",
    monthly: "Mensuel",
    yearly: "Annuel",
    billed_annually: "facturé annuellement",
    save: "Économiser",
    most_popular: "Le Plus Populaire",
    recommended: "Recommandé",
    
    starter: "Débutant",
    professional: "Professionnel",
    enterprise: "Entreprise",
    custom: "Personnalisé",
    
    searches_100: "100 recherches par mois",
    searches_500: "500 recherches par mois",
      searches_1000: "Jusqu'à 100 recherches par mois",
  searches_10000: "Jusqu'à 1 000 recherches par mois",
    unlimited_searches: "Recherches illimitées",
    
    basic_support: "Support client de base",
    priority_support: "Support client prioritaire",
    dedicated_support: "Gestionnaire de compte dédié",
    
    email_notifications: "Notifications par e-mail",
    advanced_notifications: "Notifications avancées",
    
    basic_dashboard: "Tableau de bord de base",
    detailed_reports: "Rapports détaillés",
    
    api_access: "Accès API",
    rest_api_access: "Accès API REST",
    bulk_screening: "Contrôle en masse",
    batch_screening: "Contrôle par lots",
    team_members_3: "3 membres d'équipe",
    team_members_10: "10 membres d'équipe",
    active_monitoring: "Surveillance Active",
    case_management: "Gestion des Cas",
    custom_integrations: "Intégrations personnalisées",
    white_label: "Solution en marque blanche",
    sla: "Garantie SLA",
    on_premise: "Option de déploiement sur site",
    
    get_started: "Commencer",
    upgrade_now: "Mettre à Niveau Maintenant",
    contact_sales: "Contacter les Ventes"
  }
};

export default fr;